import { useEffect, useRef } from 'react';

export const DROPDOWN_MENU_ID = 'dropdown-menu';

export const useScrollMenuIntoView = (enabled = true) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLElement | null>(null);
  const offsetHeightRef = useRef<number>(0);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (sectionRef.current) {
        const menu: HTMLElement | null = sectionRef.current.querySelector(
          `#${DROPDOWN_MENU_ID}`
        );
        if (
          menu &&
          (menuRef.current !== menu ||
            offsetHeightRef.current !== menu.offsetHeight)
        ) {
          menu.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }
        menuRef.current = menu;
        offsetHeightRef.current = menu?.offsetHeight ?? 0;
      }
    });

    if (sectionRef.current && enabled) {
      observer.observe(sectionRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [enabled]);

  return sectionRef;
};
